import React from "react";
import { motion, useReducedMotion } from "framer-motion";

export default function BrandStatement() {
  const reduce = useReducedMotion();
  const lines = ["One platform.", "One legislative picture.", "One place to act."];
  return (
    <section className="relative overflow-hidden bg-brand-navy-900 py-28 sm:py-36" data-testid="brand-statement">
      <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "linear-gradient(#3F7FB5 1px, transparent 1px), linear-gradient(90deg, #3F7FB5 1px, transparent 1px)", backgroundSize: "56px 56px" }} />
      <div className="absolute -left-24 top-1/2 h-64 w-64 -translate-y-1/2 rounded-full bg-brand-teal/20 blur-3xl" />
      <div className="absolute -right-24 top-1/3 h-72 w-72 rounded-full bg-brand-civic/20 blur-3xl" />
      <div className="relative mx-auto max-w-5xl px-5 text-center sm:px-8">
        {lines.map((l, i) => (
          <motion.p
            key={l}
            initial={reduce ? false : { opacity: 0, y: 24 }}
            whileInView={reduce ? {} : { opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            className={`font-display text-4xl font-extrabold leading-[1.08] tracking-tight sm:text-6xl ${i === 2 ? "bg-gradient-to-r from-brand-gold to-[#F0C558] bg-clip-text text-transparent" : "text-white"}`}
          >
            {l}
          </motion.p>
        ))}
      </div>
    </section>
  );
}
